import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const ArrowSolidDown = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.0002 17C11.4832 16.9974 10.9948 16.7624 10.6702 16.36L6.46021 11.26L6.46021 11.26C5.95829 10.6336 5.85738 9.77581 6.20021 9.05C6.47854 8.41856 7.1002 8.00803 7.79021 8H16.2102V8C16.9002 8.00803 17.5219 8.41856 17.8002 9.05V9.05C18.143 9.77581 18.0421 10.6336 17.5402 11.26L13.3302 16.36C13.0056 16.7624 12.5172 16.9974 12.0002 17Z",
            fill: "currentColor"
        })
    });
};
